import { ActStatuses } from "@/config/consts";
import i18n from "@/plugins/i18n";
import { AxiosResponse } from "axios";
import { LocaleMessage } from "vue-i18n";

export function translate<T>(data: T): T {
  try {
    const str = JSON.stringify(data);
    return JSON.parse(
      str.replace(
        new RegExp(`___${i18n.locale.replace(`kk`, "kz")}`, "gi"),
        "",
      ),
    );
  } catch (e) {
    return data;
  }
}
export function getImageFromAssets(name: string) {
  return require(`@/assets/${name}`);
}

export function getDiffDays(
  date1: number | string,
  date2: number | string = new Date().getTime(),
) {
  const b = new Date(date2);
  const a = new Date(date1);
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
}
export const wait = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export function isObjectEmpty(obj: object) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

export function getFileNameFromHeader(res: AxiosResponse) {
  let filename = "";
  const disposition = res.headers["content-disposition"];
  if (disposition && disposition.indexOf("attachment") !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }
  return filename;
}

export function blobToJson<T>(blob: Blob): Promise<T> {
  return new Promise(resolve => {
    const f = new FileReader();
    f.onload = () => {
      resolve(JSON.parse(f.result as string));
    };
    f.onerror = () => resolve(undefined);
    f.onabort = () => resolve(undefined);

    f.readAsText(blob, "UTF-8");
  });
}
export function isIINBIN(id: string): boolean {
  if (!id) return false;
  if (id.length != 12) return false;
  if (!/[0-9]{12}/.test(id)) return false;

  if (process.env.NODE_ENV !== "production") return true;

  //Проверяем контрольный разряд
  const b1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const b2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
  const a = [];
  let control = 0;
  for (let i = 0; i < 12; i++) {
    a[i] = parseInt(id.substring(i, i + 1));
    if (i < 11) control += a[i] * b1[i];
  }
  control = control % 11;
  if (control == 10) {
    control = 0;
    for (let i = 0; i < 11; i++) control += a[i] * b2[i];
    control = control % 11;
  }
  return control == a[11];
}

export function downloadFile(href: string): void {
  const a = document.getElementById("app-download-link") as HTMLAnchorElement;
  a.href = href;
  a.click();
}

export function objectToBase64String(object: object): string {
  return Buffer.from(JSON.stringify(object)).toString("base64");
}

export function translateSelectorItems(this: Vue, items: SelectorItem[]) {
  return items.map(item => ({
    ...item,
    text: this.$t(item.text),
  }));
}

export function getNumbersFromString(str: string): number {
  return Number(str.replace(/[^0-9]/g, ""));
}

/**
 * Removes invalid XML characters from a string
 * @param {string} str - a string containing potentially invalid XML characters (non-UTF8 characters, STX, EOX etc)
 * @param {boolean} removeDiscouragedChars - should it remove discouraged but valid XML characters
 * @return {string} a sanitized string stripped of invalid XML characters
 */
export function removeXMLInvalidChars(
  str: string,
  removeDiscouragedChars: boolean,
) {
  // remove everything forbidden by XML 1.0 specifications, plus the unicode replacement character U+FFFD
  let regex = /((?:[\0-\x08\x0B\f\x0E-\x1F\uFFFD\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g;

  // ensure we have a string
  str = String(str || "")
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(regex, "");

  if (removeDiscouragedChars) {
    // remove everything discouraged by XML 1.0 specifications
    regex = new RegExp(
      "([\\x7F-\\x84]|[\\x86-\\x9F]|[\\uFDD0-\\uFDEF]|(?:\\uD83F[\\uDFFE\\uDFFF])|(?:\\uD87F[\\uDF" +
        "FE\\uDFFF])|(?:\\uD8BF[\\uDFFE\\uDFFF])|(?:\\uD8FF[\\uDFFE\\uDFFF])|(?:\\uD93F[\\uDFFE\\uD" +
        "FFF])|(?:\\uD97F[\\uDFFE\\uDFFF])|(?:\\uD9BF[\\uDFFE\\uDFFF])|(?:\\uD9FF[\\uDFFE\\uDFFF])" +
        "|(?:\\uDA3F[\\uDFFE\\uDFFF])|(?:\\uDA7F[\\uDFFE\\uDFFF])|(?:\\uDABF[\\uDFFE\\uDFFF])|(?:\\" +
        "uDAFF[\\uDFFE\\uDFFF])|(?:\\uDB3F[\\uDFFE\\uDFFF])|(?:\\uDB7F[\\uDFFE\\uDFFF])|(?:\\uDBBF" +
        "[\\uDFFE\\uDFFF])|(?:\\uDBFF[\\uDFFE\\uDFFF])(?:[\\0-\\t\\x0B\\f\\x0E-\\u2027\\u202A-\\uD7FF\\" +
        "uE000-\\uFFFF]|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]|[\\uD800-\\uDBFF](?![\\uDC00-\\uDFFF])|" +
        "(?:[^\\uD800-\\uDBFF]|^)[\\uDC00-\\uDFFF]))",
      "g",
    );

    str = str.replace(regex, "");

    const regex2 = new RegExp("&#13;", "g");
    str = str.replace(regex2, "&#x0D;");
  }

  return str;
}

export function formatDecimal(number: number) {
  return new Intl.NumberFormat().format(number);
}

export function formatDecimal2(value: number) {
  if (value || value === 0) {
    const fixedValue = Number(value).toFixed(2);
    const dotIndex = fixedValue.indexOf(".");

    const float = fixedValue.substr(dotIndex + 1);
    const real = +fixedValue.substring(0, dotIndex);
    const parsedReal = formatDecimal(real);

    return `${parsedReal}.${float}`;
  }
}

/** returns act status by index */
export function actStatusFilter(index: number): LocaleMessage {
  return i18n.t(`actions.statuses.${ActStatuses[index]}`);
}

export function getDescendantProp(obj: Dictionary, desc: string) {
  const arr = desc.split(".");
  while (arr.length && (obj = obj[arr.shift() as string]));
  return obj;
}

/**
 * @description Creates and object to throw for ApiTranslate decorator
 */
export function makeMessageForTranslate(messageObj: ApiMessageObject) {
  return {
    response: {
      data: {
        message: messageObj,
      },
    },
  };
}

export function capitalize(str: string) {
  return str[0].toUpperCase() + str.slice(1);
}
